import { create } from "zustand";

export interface IMeetingStore {
  meetingId: string | null;
  calendarId: string | null;
  isFirstLoading: boolean;
  setMeetingId: (value: string) => void;
  setCalendarId: (value: string) => void;
  setIsFirstLoading: (value: boolean) => void;
}

const useMeetingStore = create<IMeetingStore>((set) => ({
  meetingId: null,
  calendarId: null,
  isFirstLoading: true,
  setMeetingId: (value: string) => set({ meetingId: value }),
  setCalendarId: (value: string) => set({ calendarId: value }),
  setIsFirstLoading: (value: boolean) => set({ isFirstLoading: value }),
}));

export default useMeetingStore;
